import React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Accordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

// import { OneColumnStack } from "../../../src";

const AccordionSummary = styled((props) => <MuiAccordionSummary {...props} />)(
	({ theme, ...props }) => ({
		backgroundColor:
			theme.palette.mode === "dark"
				? "rgba(255, 255, 255, .05)"
				: { ...props.backgroundColor },
		maxHeight: { ...props.maxHeight },

		"& .MuiAccordionSummary-content": {
			justifyContent: "left",
			flexGrow: 0,
			minWidth: { xs: "fit-content", md: 540 },
			outline: "0px solid red",
		},
		[theme.breakpoints.down("sm")]: {
			maxWidth: { ...props.maxWidth },
			paddingLeft: 0,
		},
	})
);

const AccordionDetails = styled((props) => <MuiAccordionDetails {...props} />)(
	({ theme, ...props }) => ({
		"&.MuiAccordionDetails-root": {
			paddingTop: { xs: 1, sm: 16 },
			paddingBottom: { xs: 1, sm: 16 },
			paddingLeft: 0,
			paddingRight: 0,
			maxWidth: { ...props.maxWidth },
		},
	})
);

const AccordionContainer = styled((props) => <Accordion {...props} />)(
	({ theme, ...props }) => ({
		"&.MuiAccordion-root": {
			"&:before": {
				backgroundColor: "#707070",
				opacity: props.opacity,
			},
			"&.Mui-expanded:before": {
				opacity: props.opacity,
			},
		},
	})
);

export default function AccordionPanel({ children = [], sx = [], ...props }) {
	if (Array.isArray(children) === false) return;

	const theme = useTheme();
	const {
		id = "panel1a-header",
		ariaControls = "panel1a-content",
		backgroundColor = theme.palette.soft.softRose150,
		label = "Add label",
		applicantName = null,
		elevation = 0,
		maxWidth = { xs: "-webkit-fill-available", sm: "100%" },
		maxHeight = 76,
		width = { xs: 311, sm: 616 },
		contentWidth = { xs: "-webkit-fill-available", sm: `calc(100% - 50px)` },
		justifyContent = "space-evenly",
		labelVariant = "h6",
		stackMargin = { xs: 2, sm: 0, md: 5 },
		summaryMargin = { xs: 0, sm: 1 },
		topBorderOpacity = 0.5,
		expanderColor = theme.palette.greyscale.Grey500,
		expanded = false,
		onClickHandler,
	} = { ...props };

	return (
		<>
			<AccordionContainer
				TransitionProps={{ unmountOnExit: true }}
				square
				disableGutters
				elevation={elevation}
				sx={{ width: maxWidth }}
				opacity={topBorderOpacity}
				expanded={expanded}
			>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon style={{ color: expanderColor }} />}
					aria-controls={ariaControls}
					id={id}
					sx={{
						mx: summaryMargin,
						backgroundColor: backgroundColor,
						minWidth: width,
						width: "-webkit-fill-available",
						maxHeight: { maxHeight },
						display: "flex",
						flexDirection: "row",
						alignItems: "center",
						py: 1,
					}}
					onClick={onClickHandler}
				>
					<Stack sx={{ textAlign: "start", ml: stackMargin }}>
						{applicantName && (
							<Typography variant="h6-bold">{applicantName}</Typography>
						)}
						<Typography variant={labelVariant}>{label}</Typography>
					</Stack>
				</AccordionSummary>

				<AccordionDetails
					sx={{
						outline: "0px solid red",
						width: width,
						display: "flex",
						flexDirection: "column",
						margin: "0 auto",
						alignItems: "flex-start",
						justifyContent: "center",
					}}
				>
					{children?.map((child, index) => {
						return (
							<Box
								key={index}
								width={contentWidth}
								sx={{ ml: { xs: 0, sm: 2 }, mr: { xs: 2, sm: 2 }, mb: 2 }}
							>
								{child}
							</Box>
						);
					})}
				</AccordionDetails>
			</AccordionContainer>
		</>
	);
}
